import { zipObject } from 'lodash/fp';

const GuestAddressFields = ['street_address', 'apartment'];

export const AddressFieldsWithPermissionMap = zipObject(
  GuestAddressFields,
  GuestAddressFields
);

export default GuestAddressFields;
